<template>
  <div class="tasks-modal">
    <div class="tasks-modal__active-tasks">
      <r-title type="subtitle-2">
        {{ $t("tasks:title-active-tasks") }}
      </r-title>
      <div
        class="tasks-modal__active-tasks__wrapper"
        v-if="activeUserTasks.length"
      >
        <TasksRenderer :tasks="activeUserTasks" />
      </div>
      <div class="tasks__no-data" v-else>
        {{ $t("tasks.no-active-tasks") }}
      </div>
    </div>

    <div class="tasks-modal__active-tasks">
      <r-title type="subtitle-2">
        {{ $t("tasks:title-finished-tasks") }}
      </r-title>
      <div
        class="tasks-modal__active-tasks__wrapper"
        v-if="finishedUserTasks.length"
      >
        <TasksRenderer :tasks="finishedUserTasks" />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import TasksRenderer from "./tasks-renderer";

export default {
  components: { TasksRenderer },
  computed: {
    allUserTasks() {
      return this.$store.state.userTasks.list || [];
    },
    activeUserTasks() {
      return this.allUserTasks
        .filter(e => !e.done)
        .sort((a, b) => {
          if (
            moment(a.start_time).format("x") > moment(b.start_time).format("x")
          )
            return -1;
          if (
            moment(a.start_time).format("x") < moment(b.start_time).format("x")
          )
            return 1;
          return 0;
        });
    },
    finishedUserTasks() {
      return this.allUserTasks
        .filter(e => e.done)
        .sort((a, b) => {
          if (
            moment(a.start_time).format("x") > moment(b.start_time).format("x")
          )
            return -1;
          if (
            moment(a.start_time).format("x") < moment(b.start_time).format("x")
          )
            return 1;
          return 0;
        });
    }
  }
};
</script>

<style lang="scss">
.tasks-modal {
  overflow: auto;
  max-height: 600px;
}
</style>

<i18n>
{
  "ru": {
    "tasks:title-active-tasks": "Активные задачи",
    "tasks:title-finished-tasks": "Завершенные задачи",
    "tasks.no-active-tasks": "Активные задачи отсутствуют"
  },
  "en": {
    "tasks:title-active-tasks": "Active tasks",
    "tasks:title-finished-tasks": "Finished tasks",
    "tasks.no-active-tasks": "No active tasks"
  }
}
</i18n>
